/**
 * Tenant configuration snapshot display.
 * Counts are shown only after admin activation. This is never a go-live percentage.
 */
export function configurationReadinessView(readiness) {
  const state = readiness && typeof readiness.state === 'string'
    ? readiness.state
    : 'no_report';

  return {
    state,
    showCounts: state === 'reported',
    showPercent: false,
  };
}
